module.exports = __webpack_public_path__ + "band_4.07319d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_4.png
// module id = KflN
// module chunks = 0